import { cn } from '@/lib/utils';
import { STATUS_FILTERS } from '../constants';
import type { Plea } from '../types';

interface StatusFilterChipsProps {
  activeFilter: string;
  onFilterChange: (key: string) => void;
  pleas: Plea[];
}

function countByStatus(pleas: Plea[], status: string): number {
  if (status === 'all') return pleas.length;
  return pleas.filter((p) => (p.status ?? 'pending').toLowerCase() === status).length;
}

export function StatusFilterChips({ activeFilter, onFilterChange, pleas }: StatusFilterChipsProps) {
  return (
    <div className="no-scrollbar mb-4 flex gap-2 overflow-x-auto pb-1" role="group" aria-label="Filtrar por status">
      {STATUS_FILTERS.map(({ key, label }) => {
        const count = countByStatus(pleas, key);
        const isActive = activeFilter === key;
        return (
          <button
            key={key}
            onClick={() => onFilterChange(key)}
            className={cn(
              'shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-medium transition-colors',
              isActive
                ? 'bg-slate-900 text-white'
                : 'border border-slate-200 bg-white text-slate-600 hover:bg-slate-50',
            )}
            aria-pressed={isActive}
          >
            {label}{count > 0 && key !== 'all' ? ` (${count})` : ''}
          </button>
        );
      })}
    </div>
  );
}
